import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import {
  Avatar,
  AvatarTypes,
  TAvatarBackgroundColorIndex,
} from '@gem/call/Removable/components/Avatar/Avatar';

interface IHugeCallAvatarProps {
  avatar: {
    title?: string | null;
    url?: string | null;
    colorIndex?: TAvatarBackgroundColorIndex | null;
  };
}
export const HugeCallAvatar: FC<IHugeCallAvatarProps> = observer(({ avatar }) => {
  return (
    <Avatar
      type={AvatarTypes.Round_50}
      title={avatar.title}
      url={avatar.url}
      backgroundColorIndex={avatar.colorIndex}
    />
  );
});
